<template>
  <li class="py-2">
    <div class="relative flex space-x-3">
      <div class="flex min-w-0 flex-1 justify-between space-x-4">
        <div>
          <p class="text-sm text-gray-500">
            {{ description }}
          </p>
        </div>
        <div class="whitespace-nowrap text-right text-xs text-gray-500">
          <time :datetime="datetime">{{ date }}</time>
        </div>
      </div>
    </div>
  </li>
</template>

<script>
import moment from 'moment';

export default {
  props: {
    activityLog: {
      type: Object,
      required: true,
    },
  },
  computed: {
    description() {
      if (this.activityLog.description.includes(':causer') === false) {
        return this.activityLog.description;
      }

      let causer = 'System';

      if (
        this.activityLog.causer_type === 'users' &&
        typeof this.activityLog.causer?.fullName === 'string'
      ) {
        causer =
          this.activityLog.causer_id === this.$user.id ? 'You' : this.activityLog.causer.fullName;
      }

      return this.activityLog.description.replace(':causer', causer);
    },
    datetime() {
      return moment.utc(this.activityLog.created_at).local().format('YYYY-MM-DD');
    },
    date() {
      const created = moment.utc(this.activityLog.created_at).local();

      if (moment().diff(created, 'years') > 0) {
        return created.format('D MMM YY [at] h:mm a');
      }

      if (moment().diff(created, 'days') === 0) {
        return created.format('[Today at] h:mm a');
      }

      return created.format('D MMM [at] h:mm a');
    },
  },
};
</script>
